import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CommercialCleaning from "../pages/services/commercial-cleaning/page";
import PostConstruction from "../pages/services/post-construction/page";
import HealthcareFacility from "../pages/services/healthcare-facility/page";
import StripWaxCarpet from "../pages/services/strip-wax-carpet/page";
import WindowCleaning from "../pages/services/window-cleaning/page";
import SnowRemoval from "../pages/services/snow-removal/page";
import ForeclosedHome from "../pages/services/foreclosed-home/page";
import FacilityManagement from "../pages/services/facility-management/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services/commercial-cleaning",
    element: <CommercialCleaning />,
  },
  {
    path: "/services/post-construction",
    element: <PostConstruction />,
  },
  {
    path: "/services/healthcare-facility",
    element: <HealthcareFacility />,
  },
  {
    path: "/services/strip-wax-carpet",
    element: <StripWaxCarpet />,
  },
  {
    path: "/services/window-cleaning",
    element: <WindowCleaning />,
  },
  {
    path: "/services/snow-removal",
    element: <SnowRemoval />,
  },
  {
    path: "/services/foreclosed-home",
    element: <ForeclosedHome />,
  },
  {
    path: "/services/facility-management",
    element: <FacilityManagement />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;